export default __webpack_public_path__ + "static/media/robert-downey-jr.05a60579.jpeg";